import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
    height: "100%"
  },
  user1: {},
  user2: {},
  user3: {
    height: "95px"
  },
  user5: {
    height: "61px"
  },
  divider: {
    width: "90%",
    margin: "auto"
  },
  section: {
    marginBottom: theme.spacing(3)
  },
  endCalc: {
    marginBottom: theme.spacing(6)
  },
  predictedAmount: {
    [theme.breakpoints.up("md")]: {
      width: "14vw"
    },
    [theme.breakpoints.down("md")]: {
      width: "50vw"
    },
    border: "2px solid",
    borderRadius:"2px", 
    borderColor: "#434040",
    color: "#FB7906",
    padding: "8px 20px",
    margin: "auto",
    marginTop: "3vmax",
    marginBottom: "2vmax",
    cursor: "not-allowed"
  },
  cardImage: {
    width: "100%",
    position: "absolute",
    margin: "auto",
    left: 0,
    right: 0,

    fill: theme.kooee.text.primary,
    stroke: theme.kooee.text.primary,
    strokeWidth: "2",
    [theme.breakpoints.up("md")]: {
      height: "3em",
      // top: "1em"
    },
    [theme.breakpoints.down("sm")]: {
      height: "3em"
    },
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      height: "3em"
    }
  },
  cardImageActive: {
    fill: "#434040",
    stroke: "#434040"
  },
  changeButton: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    color:"#fff",
    backgroundColor:"#696969",
    borderRadius:"0px 8px"
  },
  continueButton: {
    marginTop: theme.spacing(2),
    padding: "1em 2em",
    color:"#fff",
    backgroundColor:"#FB7906",
    '&:hover': {
      backgroundColor: '#e46b00',
      boxShadow:"0px 0px 5px #e46b00"
    },
    borderRadius:"0px 8px"
  },
  postalInput: {
    marginTop: theme.spacing(4)
  },
  postalDisplay: {
    [theme.breakpoints.up("md")]: {
      width: "25vw"
    },
    [theme.breakpoints.down("md")]: {
      width: "80vw"
    }
  },
  buttonProgress: {
    color: theme.kooee.backgrounds.secondary,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  sliderWrapper: {
    marginTop: theme.spacing(1)
  },
  headerTitles: {
    fontWeight: 600,
    color: theme.kooee.titles.primary
  },
  itemCards: {
    width: "12vw !important"
  }
}));
